<template>
    <div :class="`player ${color ? `hasColor` : ''}`">
        <!-- <span class="description">{{ attach.title }}&nbsp;</span>
        <p style="font-size: 20px;line-height: 30px;margin: 0 auto 40px;max-width: 90%;text-align: left;">{{ attach.data.subtitle }}&nbsp;</p> -->
        <div
            :style="color ? `background-color: ${color}` : ''"
            class="playerOuter"
        >
            <div class="playerWrapper">
                <!--
            /> -->
                <div class="player">

                    <p class="center">
                        <a
                            :href="`/transcript/${attach.id}`"
                            class="readItButton"
                            style="font-size: 13px;"
                        >
                            READ IT
                        </a>
                        <a
                            v-if="(url === isPlayingContent) && isLoadingAudio"
                            :style="color ? `background-color: ${color}` : ''"
                            href="#"
                            class="playButton"
                        >
                            <i class="ion-ios-cloud-download-outline animPulse" />
                        </a>
                        <a
                            v-else
                            :style="color ? `background-color: ${color}` : ''"
                            href="#"
                            class="playButton"
                            @click="togglePlayback"
                        >
                            <i
                                :class="(!isPlaying || url !== isPlayingContent) ? 'ion-ios-play' : 'ion-ios-pause'"
                                :style="(!isPlaying || url !== isPlayingContent) ? 'padding-left: 6px' : 'padding-left: 1px'"
                            />
                        </a>
                        <a
                            href="#"
                            class="stopButton resetButton"
                            style="font-size: 13px;"
                            @click="restartPlayback"
                        >
                            RESET
                        </a>
                    </p>
                    <div class="progressLine swiper-no-swiping">
                        <f7-range
                            :min="0"
                            :max="100"
                            :step="1"
                            :value="progress ? progress * 100 : 0"
                            class="rangef7"
                            @range:change="doSeek2"
                        />
                        <!-- <input
                            id="seek"
                            :value="0"
                            :min="0"
                            :max="100"
                            type="range"
                            style="width: 100%; height: 12px; position: absolute; top: -6px; left: -4px; opacity: 0.1; z-index: 99999999"
                            @click="doSeek($event.target.value, $event);"
                        > -->
                        <!-- @change="doSeek($event.target.value, $event)" -->
                        <div
                            :style="`width: ${progress ? progress * 100 : 0}%;`"
                            class="progressLinePc"
                        >
                            <div class="ballTip" />
                        </div>
                    </div>
                    <p
                        class="center"
                        style="line-height: 10px;"
                    >
                        <span :key="`attach-audio-${attach.slideId}`">{{ seekDisplay(seek) }}</span> /
                        <span>{{ duration ? formatSecondsAsTime(duration) : formatSecondsAsTime(attach.data.duration || 0) }}</span>
                    </p>

                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    store: ['isPlaying', 'isLoadingAudio', 'isPlayingContent', 'isPlayingData', 'audioSources', 'unitsIndex', 'attachment'],
    props: ['attach', 'url', 'unit', 'color'],
    data () {
        return {
            isClick: false,
            seek: 0,
            progress: 0,
            progressPc: 0,
            duration: 0
        };
    },
    created: function () {
        // console.log('Local Audioplayer created');
        this.attachment = this.attach;
        this.$events.on(`player:status:${this.url}`, data => {
            this.progress = isNaN(parseFloat(data.progress)) ? 0 : parseFloat(data.progress);
            this.progressPc = isNaN(parseFloat(this.progress)) ? 0 : parseFloat(this.progress) * 100;
            this.seek = isNaN(parseFloat(data.seek)) ? 0 : parseFloat(data.seek);
            this.duration = isNaN(parseFloat(data.duration)) ? 0 : parseFloat(data.duration);
        });
    },
    methods: {
        seekDisplay: function (seek) {
            if (seek && !isNaN(parseFloat(seek)) && seek <= 3540 && seek > 0) {
                return this.formatSecondsAsTime(seek);
            }
            return '00:00';
        },
        doSeek2: function (pc) {
            // prevent natural skipping
            if (pc > this.progressPc + 4 || pc === 0 || pc < this.progressPc - 4) {
                if (pc === 0 && this.progressIsBeingChanged) return;
                this.$events.fire('player:seek', pc);
                this.progressIsBeingChanged = true;
                setTimeout(() => {
                    this.progressIsBeingChanged = false;
                }, 700);
                if (this.unit && this.isPlayingData.id && this.unitsIndex[this.isPlayingData.id]) {
                    try {
                        Vue.set(this.unitsIndex[this.isPlayingData.id], 'progress', parseInt(this.progress * 100, 10));
                    } catch (e) {
                        console.error('[Player] could not update progress');
                    }
                }
            }
        },
        doSeek: function (pc, e) {
            // console.log('Seek', e)
            this.progressIsBeingChanged = true;
            setTimeout(() => {
                this.progressIsBeingChanged = false;
            }, 1200);
            if (pc === '0' && pgap) {
                // ios range starts at zero so you have to drag
                pc = (e.offsetX * 100) / e.target.scrollWidth;
                // console.log(pc, e.offsetX, e.target.scrollWidth)
                this.progressInput = parseFloat(pc);
            }
            this.$events.fire('player:seek', parseFloat(pc));
        },
        togglePlayback: function () {
            // console.log(this.url, this.isPlayingContent)
            if (this.url !== this.isPlayingContent) {
                this.audioSources = [this.attach.data.audioUrl];
                this.isPlayingContent = this.url;
                this.isPlayingData = this.unit;
                this.$events.fire('trackEvent', `audio_play`, 'actions', this.unit.id, this.unit.name);
                if (!pgap) this.$events.fire('player:play');
                return;
            }
            // has to happen before trigger due to how event works on pgap
            this.$events.fire('player:togglePlayback');
            if (this.unit && this.isPlayingData.id && this.unitsIndex[this.isPlayingData.id]) {
                try {
                    Vue.set(this.unitsIndex[this.isPlayingData.id], 'progress', parseInt(this.progressPc, 10));
                } catch (e) {
                    console.error('[Player] could not update progress');
                }
            }
        },
        restartPlayback: function () {
            this.$events.fire('player:stop', true);
        },
        formatSecondsAsTime: secs => {
            var hr = Math.floor(secs / 3600);
            var min = Math.floor((secs - hr * 3600) / 60);
            var sec = Math.floor(secs - hr * 3600 - min * 60);
            if (min < 10) {
                min = '0' + min;
            }
            if (sec < 10) {
                sec = '0' + sec;
            }
            return min + ':' + sec;
        }
    }
};
</script>



<style lang="less" scoped>
@import '../../css/colors.less';
.description {
    font-family: Editor-Light;
    font-size: 20px;
    color: @darkGray;
    text-align: center;
    line-height: 24px;
}
.playerOuter {
    width: 100%;
    height: 88px;
    background: @taupe;
}
.playerWrapper {
    max-width: 300px;
    margin: 0 auto;
}
.stopButton,
.playButton {
    color: @coral;
    i {
        color: @coral !important;
    }
    font-size: 30px;
    line-height: 30px;
}
.resetButton {
    color: @coral;
}
.hasColor {
    .playButton {
        color: white;
        i {
            color: white !important;
        }
    }
}
.readItButton {
    color: white;
    margin-left: -53px;
    padding-right: 7px;
}
.player {
    text-transform: uppercase;
    font-family: AndesMedium;
    font-size: 13px;
    color: white;
}
.progressLine {
    margin-top: 42px;
    position: relative;
    height: 4px;
    background: white;
    border-radius: 2px;
    width: 100%;
}
.rangef7 {
    position: absolute;
    opacity: 0;
    top: -12px;
}
.progressLinePc {
    margin-top: -28px;
    height: 4px;
    background: @coral;
}
.ballTip {
    float: right;
    margin-top: -2px;
    margin-right: -2px;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background: @coral;
}
// .playerBg {
//     background: @green;
//     opacity: 0.5;
//     height: 220px;
//     margin: 10px 0;
//     z-index: 7;
//     position: relative;
// }
// .player {
//     position: relative;
//     z-index: 8;
//     height: 210px;
//     overflow: hidden;
//     margin: -230px 0 10px;
//     padding: 5px 10px;
//     text-align: left;
//     box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
//     .block-title {
//         margin: 10px 0;
//     }
//     h3 {
//         margin: 0;
//         padding: 0;
//         font-size: 20px;
//     }
.stopButton {
    left: 50%;
    color: white;
    font-size: 30px;
    margin-right: -50px;
    margin-left: 20px;
}
.playButton {
    margin-left: 14px;
    margin-top: -40px;
    i {
        margin-top: -40px;
    }
    display: inline-block;
    left: 50%;
    width: 70px;
    height: 70px;
    padding-bottom: 20px;
    border-radius: 50%;
    border: 1px solid white;
    color: white;
    font-size: 40px;
    line-height: 77px;
    text-align: center;
    background: @taupe;
    &.active-state {
        color: white;
        background: @coral;
        i {
            color: white !important;
        }
    }
}
// }
</style>
